module.exports = __webpack_public_path__ + "static/media/search.4ca8d41f.svg";